<ng-template #legendTpl let-margin="margin">
  <div class="intro-legend" [style.margin]="margin" style="grid-column:1 / -1;display:flex;justify-content:center;flex-wrap:wrap;gap:20px;font-size:11px;color:var(--g500);">
    <span style="display:inline-flex;align-items:center;gap:6px;"><i style="width:10px;height:10px;border-radius:50%;background:#34C759;display:inline-block;"></i>{{ 'results.legend.good' | translate }}</span>
    <span style="display:inline-flex;align-items:center;gap:6px;"><i style="width:10px;height:10px;border-radius:50%;background:#FF9F0A;display:inline-block;"></i>{{ 'results.legend.watch' | translate }}</span>
  </div>
</ng-template>

<div class="qa-intro-head">
  <span class="qa-intro-eyebrow">{{ (vm.firstName ? 'results.intro.greeting' : 'results.intro.greetingNoName') | translate: { name: vm.firstName } }}</span>
  <h2 class="qa-intro-title">{{ 'results.intro.title' | translate }}</h2>
  <p class="qa-intro-sub">{{ 'results.intro.sub' | translate }}</p>
</div>

<div class="intro-summary-grid">
  <ng-container *ngFor="let d of domains">
    <!-- scored domain card -->
    <div
      *ngIf="d.id !== 'routine'"
      class="intro-summary-card"
      [ngClass]="d.toneClass"
      (click)="goPanel.emit(d.panelId)"
      style="cursor:pointer;"
    >
      <!-- wordfirst sec 1: NO score ring on the overview (a ring reads as a
           precise measurement / false precision even without a digit). Word-first:
           verdict word + colour dot, the number lives only inside the panel. -->
      <div class="intro-card-content">
        <div class="intro-card-top">
          <div *ngIf="!d.subtitleKey" class="intro-card-title">{{ d.titleKey | translate }}</div>
          <div *ngIf="d.subtitleKey" class="intro-card-title-wrap">
            <div class="intro-card-title" [attr.dir]="d.titleLtr ? 'ltr' : null">{{ d.titleKey | translate }}</div>
            <div class="intro-card-subtitle">{{ d.subtitleKey | translate }}</div>
          </div>
        </div>
        <div
          class="intro-card-tag"
          [style.background]="d.band ? d.band.tagBg : (d.available ? savedTag.bg : emptyTag.bg)"
          [style.color]="d.band ? d.band.tagColor : (d.available ? savedTag.color : emptyTag.color)"
        >
          <span class="ov-dot" [style.background]="d.band ? d.band.ringColor : (d.available ? '#34C759' : '#c8c8cc')"></span>
          {{ (d.band ? d.band.labelKey : (d.available ? 'results.bands.saved' : 'results.bands.notCompleted')) | translate }}
        </div>
        <p class="intro-card-insight">{{ d.insightKey | translate }}</p>
      </div>
      <svg class="intro-card-chev" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
    </div>

    <!-- Danna 26.09 (app): the legend explains the result cards only, so in the app it sits right after SENSE, above Your tools. -->
    <ng-container *ngIf="d.id === 'routine'" [ngTemplateOutlet]="legendTpl" [ngTemplateOutletContext]="{ margin: '2px auto' }"></ng-container>
    <!-- routine "connect" card (locked in Option A, free in B) -->
    <div
      *ngIf="d.id === 'routine'"
      class="intro-summary-card qa-connect"
      [class.qa-locked]="routineLocked"
      (click)="routineLocked ? goPaywall.emit() : goPanel.emit(d.panelId)"
      style="cursor:pointer;"
    >
      <div class="hi-ring-col">
        <div class="qa-connect-ring" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="6.5" cy="12" r="2.4"></circle><circle cx="17.5" cy="6.5" r="2.4"></circle><circle cx="17.5" cy="17.5" r="2.4"></circle>
            <path d="M8.6 11L15.4 7.6"></path><path d="M8.6 13L15.4 16.4"></path>
          </svg>
        </div>
        <span class="qa-lock-badge" *ngIf="routineLocked" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>
        </span>
      </div>
      <div class="intro-card-content">
        <div class="intro-card-top"><div class="intro-card-title">{{ (routineLocked ? 'results.locked.routineTitle' : d.titleKey) | translate }}</div></div>
        <p class="intro-card-insight">{{ (routineLocked ? 'results.locked.routineBody' : d.insightKey) | translate }}</p>
      </div>
    </div>
  </ng-container>

  <!-- wordfirst sec 3/6: green (good) + amber (watch). The top tier uses DEEP amber
       (--status-amber-deep, same hue as amber, darker) which is deliberately the same
       amber family, NOT a third colour and NOT red — so the legend stays two dots
       (good/watch); the spec mockup carries no legend at all. Never add a red item. -->
  <!-- Danna 26.09: the legend belongs to the result cards, so it sits right under them, above the doctor report. -->
  <ng-container *ngIf="!hasRoutine" [ngTemplateOutlet]="legendTpl" [ngTemplateOutletContext]="{ margin: '2px auto' }"></ng-container>

  <!-- doctor-report "connect" card — paid-4, locked for unpaid (both A & B) -->
  <div class="intro-summary-card qa-connect qa-doctor" [class.qa-locked]="doctorLocked" (click)="doctorLocked ? goPaywall.emit() : goDoctor.emit()" style="cursor:pointer;">
    <div class="hi-ring-col">
      <div class="qa-connect-ring" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round">
          <path d="M9 4h6a1 1 0 0 1 1 1 1 1 0 0 1-1 1H9a1 1 0 0 1-1-1 1 1 0 0 1 1-1z"></path>
          <path d="M8 5H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"></path>
          <path d="M9 12h6M9 16h6"></path>
        </svg>
      </div>
      <span class="qa-lock-badge" *ngIf="doctorLocked" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>
      </span>
    </div>
    <div class="intro-card-content">
      <div class="intro-card-top"><div class="intro-card-title">{{ (doctorLocked ? 'results.locked.doctorTitle' : 'results.domains.doctor.title') | translate }}</div></div>
      <p class="intro-card-insight">{{ (doctorLocked ? 'results.locked.doctorBody' : 'results.domains.doctor.insight') | translate }}</p>
    </div>
  </div>
</div>

<div class="mobile-guided-journey" [attr.aria-label]="'results.journey.ariaLabel' | translate">
  <div class="mobile-journey-hero">
    <div class="mobile-journey-kicker">
      <span></span>
      {{ 'results.journey.kicker' | translate }}
    </div>
    <div class="mobile-journey-title">{{ 'results.journey.title' | translate }}</div>
    <p class="mobile-journey-copy">{{ 'results.journey.copy' | translate }}</p>
  </div>

  <div class="mobile-journey-steps mobile-score-steps">
    <ng-container *ngFor="let d of domains; let i = index">
    <ng-container *ngIf="d.id === 'routine'" [ngTemplateOutlet]="legendTpl" [ngTemplateOutletContext]="{ margin: '4px auto 6px' }"></ng-container>
    <button
      class="mobile-journey-step"
      type="button"
      [class.qa-locked]="d.id === 'routine' && routineLocked"
      [attr.data-panel]="d.panelId"
      (click)="(d.id === 'routine' && routineLocked) ? goPaywall.emit() : goPanel.emit(d.panelId)"
    >
      <span class="mobile-journey-num">{{ i + 1 }}</span>
      <span *ngIf="d.id === 'routine'" class="mobile-step-connect" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="6.5" cy="12" r="2.2"></circle><circle cx="17.5" cy="6.5" r="2.2"></circle><circle cx="17.5" cy="17.5" r="2.2"></circle>
          <path d="M8.5 11.1L15.4 7.5"></path><path d="M8.5 12.9L15.4 16.5"></path>
        </svg>
      </span>
      <span class="mobile-journey-main">
        <span class="mobile-journey-name" [attr.dir]="d.titleLtr ? 'ltr' : null">{{ ((d.id === 'routine' && routineLocked) ? 'results.locked.routineTitle' : d.titleKey) | translate }}</span>
        <span *ngIf="d.subtitleKey" class="mobile-journey-subtitle">{{ d.subtitleKey | translate }}</span>
        <!-- wordfirst: replaces the removed score ring — verdict word + colour dot -->
        <span *ngIf="d.id !== 'routine' && d.band" class="mobile-journey-verdict" [style.color]="d.band.tagColor">
          <span class="ov-dot" [style.background]="d.band.ringColor"></span>{{ d.band.labelKey | translate }}
        </span>
        <span class="mobile-journey-desc">{{ ((d.id === 'routine' && routineLocked) ? 'results.locked.routineBody' : d.journeyDescKey) | translate }}</span>
      </span>
      <span class="mobile-journey-status">{{ d.journeyStatusKey | translate }}</span>
      <span class="mobile-journey-lock" *ngIf="d.id === 'routine' && routineLocked" aria-hidden="true">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>
      </span>
      <svg *ngIf="!(d.id === 'routine' && routineLocked)" class="mobile-journey-arrow" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="15 18 9 12 15 6"></polyline></svg>
    </button>
    </ng-container>

    <ng-container *ngIf="!hasRoutine" [ngTemplateOutlet]="legendTpl" [ngTemplateOutletContext]="{ margin: '4px auto 6px' }"></ng-container>

    <button class="mobile-journey-step" type="button" data-panel="doctor" [class.qa-locked]="doctorLocked" (click)="doctorLocked ? goPaywall.emit() : goDoctor.emit()">
      <span class="mobile-journey-num">{{ domains.length + 1 }}</span>
      <span class="mobile-step-connect" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M9 4h6a1 1 0 0 1 1 1 1 1 0 0 1-1 1H9a1 1 0 0 1-1-1 1 1 0 0 1 1-1z"></path>
          <path d="M8 5H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"></path>
          <path d="M9 12h6M9 16h6"></path>
        </svg>
      </span>
      <span class="mobile-journey-main">
        <span class="mobile-journey-name">{{ (doctorLocked ? 'results.locked.doctorTitle' : 'results.domains.doctor.title') | translate }}</span>
        <span class="mobile-journey-desc">{{ (doctorLocked ? 'results.locked.doctorBody' : 'results.domains.doctor.journeyDesc') | translate }}</span>
      </span>
      <span class="mobile-journey-status" *ngIf="!doctorLocked">{{ 'results.journey.notViewed' | translate }}</span>
      <span class="mobile-journey-lock" *ngIf="doctorLocked" aria-hidden="true">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>
      </span>
      <svg *ngIf="!doctorLocked" class="mobile-journey-arrow" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="15 18 9 12 15 6"></polyline></svg>
    </button>
  </div>

  <div class="mobile-swipe-hint" aria-hidden="true">
    <span class="mobile-swipe-text">{{ 'results.journey.swipe' | translate }}</span>
    <span class="mobile-swipe-track"><span></span></span>
  </div>
</div>

<!-- Surface split B4: on the web the "Your tools" card becomes the app-download card. -->
<app-download-card *ngIf="!isNative" variant="card" placement="report"></app-download-card>

<div class="intro-next-hint">
  <span>{{ 'results.journey.swipe' | translate }}</span>
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"></polyline></svg>
</div>
